module.exports = __webpack_public_path__ + "b3568eed33e24afa09d9adea05fa3af2.png";